import { useCartContext } from "app/providers/CartProvider";
import ProductItemCheckout from "entities/product-item-checkout";
import CheckoutProductControls from "features/checkout/product-controls";
import CheckoutProductControlsSampleSale from "features/checkout/product-controls-sample-sale";
import {
  zakelijkDoorCodes,
  zakelijkProfielCodes,
} from "features/option-controls/door-width-controls/ZakelijkHelper";
import { Product } from "shared/api/middleware-api-client";
import { concatClassnames } from "shared/utils/concatClassnames";
import ProfielProductItem from "./ProfielProductItem";
import { ZakelijkProductItem } from "./ZakelijkProductItem";

interface CheckoutDoorListProps {
  products: Product[];
}
const CheckoutDoorList = ({ products }: CheckoutDoorListProps) => {
  const { isSampleSale } = useCartContext();

  return (
    <div>
      {products.map((product, id) => {
        //Is zakelijk product
        const isZakelijkProduct = zakelijkDoorCodes.includes(
          product.doorType.code,
        );
        return (
          <div
            key={`product-${id}`}
            className={concatClassnames(
              "gg-grid gg-grid-cols-12 gg-items-start",
              id !== products.length - 1 && "gg-border-b",
              id !== 0 && "gg-pt-9",
              id !== products.length - 1 ? "lg:gg-pb-9" : "lg:gg-pb-2",
            )}
          >
            {isZakelijkProduct ? (
              <ZakelijkProductItem product={product} index={id} />
            ) : (
              <ProductItemCheckout
                product={product}
                controls={
                  isSampleSale ? (
                    <CheckoutProductControlsSampleSale index={id} />
                  ) : (
                    <CheckoutProductControls index={id} />
                  )
                }
                reorderControl={isSampleSale}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
export default CheckoutDoorList;
